import { FlexContainer, Text } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const InfoContainer = styled(FlexContainer)`
  width: 358px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 100%;
  }
`;

export const Price = styled(Text)`
  text-decoration: line-through;
`;

export const PriceContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const BulletContainer = styled(FlexContainer)`
  svg {
    width: 10%;
  }
  p {
    width: 90%;
  }
`;
